// ── Acento de marca de la cuenta (2026-08-31) ────────────────────────────────
// El color de los botones en los correos que salen CON LA MARCA DE LA CUENTA:
// hoy, los avisos de cobro a sus clientes (server/services/clientPayments/
// notices.ts).
//
// No confundir con FORM_THEME_DEFAULTS.primary, que es el acento de UN
// formulario público: dos formularios de la misma cuenta pueden tener colores
// distintos a propósito. Esto es el color del ESTUDIO, uno solo, al lado del
// logo en Settings → General.
//
// Se guarda en el setting `brand_accent` de la DB de cada cuenta. Vacío o
// ausente = sin acento propio, y se usa este default, que es el acento de
// EvoHub — el mismo que tenían esos correos antes de que el campo existiera.
export const BRAND_ACCENT_SETTING_KEY = 'brand_accent';
export const BRAND_LOGO_SETTING_KEY = 'brand_logo_path';
export const BRAND_ICON_SETTING_KEY = 'brand_icon_path';
export const BRAND_TEXT_SETTING_KEY = 'brand_text';
export const BRAND_BG_SETTING_KEY = 'brand_bg';
export const BRAND_PAGE_BG_SETTING_KEY = 'brand_page_bg';
/** Todas las claves de marca, para iterar sin olvidarse ninguna. */
export const BRAND_SETTING_KEYS = [
    BRAND_LOGO_SETTING_KEY, BRAND_ICON_SETTING_KEY,
    BRAND_ACCENT_SETTING_KEY, BRAND_TEXT_SETTING_KEY,
    BRAND_BG_SETTING_KEY, BRAND_PAGE_BG_SETTING_KEY,
];
export const BRAND_ACCENT_DEFAULT = '#0ea5e9';
/** Texto sobre el acento. Oscuro y no blanco por el mismo motivo que en los
 *  formularios: los acentos de marca suelen ser claros, y un blanco encima
 *  queda ilegible. */
export const BRAND_ACCENT_TEXT = '#0A0A0A';
const HEX_RE = /^#[0-9a-fA-F]{6}$/;
/** El acento guardado, o el default. Valida el formato: un valor corrupto en
 *  settings no puede terminar como un `background:` roto en el correo de un
 *  cliente. */
export function resolveBrandAccent(stored) {
    return stored && HEX_RE.test(stored) ? stored : BRAND_ACCENT_DEFAULT;
}
// ── La marca completa de una cuenta (2026-09-01) ─────────────────────────────
// Una sola definición para todo lo que sale con la cara de la cuenta:
// formularios públicos, correos de cobro, documentos y portal del cliente.
//
// Antes cada formulario tenía su propia apariencia. El resultado real,
// verificado en producción: tres formularios de una misma cuenta con el mismo
// acento pero distinto color de texto, y un logo que no era el de la cuenta.
// Nadie eligió eso — se fue acumulando panel por panel.
//
// LOS DEFAULTS SON LOS DE ANTES, a propósito. Son exactamente los valores que
// tenía FORM_THEME_DEFAULTS, así que una cuenta que nunca cargó marca ve
// exactamente lo mismo que veía.
export const BRAND_TEXT_DEFAULT = '#1e293b';
export const BRAND_BG_DEFAULT = '#ffffff';
export const BRAND_PAGE_BG_DEFAULT = '#f1f5f9';
/** Fondo transparente: no se pinta nada y se ve lo que haya detrás. Es el caso
 *  que más sirve al incrustar en el sitio de un cliente, y por eso es un valor
 *  propio y no un hex. */
export const BRAND_TRANSPARENT = 'transparent';
function hexOr(valor, porDefecto) {
    return valor && HEX_RE.test(valor) ? valor : porDefecto;
}
/** Una capa de fondo: `transparent` se respeta, un hex válido se usa, y
 *  cualquier otra cosa cae al default. null significa transparente. */
function bgOr(valor, porDefecto) {
    if (valor === BRAND_TRANSPARENT)
        return null;
    return hexOr(valor, porDefecto);
}
export function resolveAccountBrand(raw) {
    return {
        logoPath: raw.logoPath || null,
        iconPath: raw.iconPath || null,
        accent: resolveBrandAccent(raw.accent),
        text: hexOr(raw.text, BRAND_TEXT_DEFAULT),
        bg: bgOr(raw.bg, BRAND_BG_DEFAULT),
        pageBg: bgOr(raw.pageBg, BRAND_PAGE_BG_DEFAULT),
    };
}
//# sourceMappingURL=brand.js.map